import { render, staticRenderFns } from "./main_records.vue?vue&type=template&id=05264a4c&scoped=true"
import script from "./main_records.vue?vue&type=script&lang=js"
export * from "./main_records.vue?vue&type=script&lang=js"
import style0 from "./main_records.vue?vue&type=style&index=0&id=05264a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05264a4c",
  null
  
)

export default component.exports